import { Button } from '@mui/material';
import { styled as muiStyled } from "@mui/material/styles";
import styles from './index.module.scss';
interface Detail {
  titleText: string;
  price: string;
  priceColor: string;
  sign?: string;
}
interface Props {
  hintText: string;
  summaryText: string;
  summaryPrice: string;
  detailList: Detail[];
  symbol: string;
  popupTitle: string;
  onConfirm?:()=> {}
}

const ConfirmButton = muiStyled(Button)(() => ({
  color: "#fff",
  backgroundColor: "#CC0C1C",
  lineHeight: "28px",
  padding: "0 8px",
  minWidth: "auto",
  "&:hover": {
    borderColor: "#990915",
    backgroundColor: "#990915",
    boxShadow: "none",
  }
}));

export default function FinalPriceDrawerContent({
  summaryText,
  summaryPrice,
  detailList,
  symbol,
  hintText,
  popupTitle,
  onConfirm
}: Props) {

  return <div className={styles.finalPriceDrawer}>
    <div className={styles.title}>{popupTitle}</div>
    <div className={styles.detailItemList}>
    {
      detailList?.map((item: Detail, index) => {
        return <div className={styles.detailItem} key={`final-detail-${index}`}>
          <span>{item.titleText}</span>
          <span style={{color: item?.priceColor}}>
            {item?.sign || ''}
            {symbol || ''}
            {item.price}
          </span>
        </div>
      })
    }
    </div>
    <div className={styles.summary}>
      <span dangerouslySetInnerHTML={{__html: summaryText}}></span>
      <span>
        {symbol}{summaryPrice}
      </span>
    </div>
    <div className={styles.hint}>
      {hintText}
    </div>
    <div className={styles.btnWrap}>
      <ConfirmButton onClick={onConfirm}>OK</ConfirmButton>
    </div>
    
  </div>
}